<template>
    <div>
        <a class="btn btn-lg btn-danger w-100 px-0" href="#" @click.prevent="handleLogout">
            <span>Déconnexion</span>
        </a>

        <slot />
    </div>
</template>

<script>
export default {
    name: "DisconnectBtn.vue",
    methods: {
        handleLogout() {
            this.$store.dispatch('logout');

            document.getElementById('logout-form').submit();
        }
    }
}
</script>

<style scoped>

</style>
